export const apiRoutes = [
  {
    title: 'Authentication & User',
    id: 'authentication_user',
    routes: [
      {
        pathName: 'user',
        method: 'GET',
        params: null,
        encodedParams: '',
      },
      {
        pathName: 'login',
        method: 'POST',
        paramsType: 'authParams',
        encodedParams: `-d '{ "email": "example@email.com", "password": "somethingsafe" }'`,
      },
    ],
  },
  {
    title: 'Report Actions',
    id: 'report_actions',
    routes: [
      {
        pathName: 'scan',
        method: 'POST',
        params: {
          url: true,
        },
        paramsType: 'crawlParams',
        encodedParams: `-d '{ "url": "https://mywebsite.com" }'`,
      },
      {
        pathName: 'crawl',
        method: 'POST',
        paramsType: 'crawlParams',
        encodedParams: `-d '{ "url": "https://mywebsite.com" }'`,
      },
      {
        pathName: 'websites-sync',
        method: 'POST',
        params: null,
        encodedParams: ``,
      },
    ],
  },
  {
    title: 'Website Management',
    id: 'website_management',
    routes: [
      {
        pathName: 'website',
        method: 'POST',
        paramsType: 'websiteParams',
        encodedParams: `-d '{ "websiteUrl": "https://mywebsite.com" }'`,
      },
      {
        pathName: 'website?domain=https://mywebsite.com',
        method: 'GET',
        params: {
          url: true,
        },
        paramsType: 'websiteParams',
        encodedParams: '',
      },
      {
        pathName: 'website',
        method: 'PUT',
        paramsType: 'websiteParams',
        encodedParams: `-d '{ "url": "https://mywebsite.com" }'`,
      },
      {
        pathName: 'website',
        method: 'DELETE',
        paramsType: 'websiteParams',
        params: {
          url: {
            desc: '',
            optional: true,
          },
          domain: {
            type: 'string',
            desc: '',
            optional: true,
          },
          deleteMany: {
            type: 'boolean',
            desc: '',
            optional: true,
          },
        },
        encodedParams: `-d '{ "domain": "a11ywatch.com" }'`,
      },
      {
        pathName: 'report?url=https://mywebsite.com',
        method: 'GET',
        paramsType: 'crawlParams',
        params: {
          url: {
            desc: '',
            optional: false,
          },
          download: {
            type: 'boolean',
            desc: '',
            optional: true,
          },
          csv: {
            type: 'boolean',
            desc: '',
            optional: true,
          },
        },
        encodedParams: '',
      },
      {
        pathName: 'analytics?url=https://mywebsite.com',
        method: 'GET',
        params: {
          url: {
            desc: '',
            optional: false,
          },
        },
        encodedParams: '',
      },
      {
        pathName: 'website/export-pdf?url=https://mywebsite.com',
        method: 'GET',
        paramsType: 'crawlParams',
        params: {
          url: {
            desc: '',
            optional: false,
          },
        },
        encodedParams: '',
      },
    ],
  },
  {
    title: 'List Results',
    id: 'list_results',
    routes: [
      {
        pathName: 'list/website?offset=0',
        method: 'GET',
        params: {
          offset: {
            type: 'number',
            desc: '',
            optional: true,
          },
          search: {
            type: 'string',
            desc: '',
            optional: true,
          },
        },
      },
      {
        pathName: 'list/issue?offset=0&domain=a11ywatch.com',
        method: 'GET',
        params: {
          offset: {
            type: 'number',
            desc: '',
            optional: true,
          },
          domain: {
            type: 'string',
            desc: '',
            optional: true,
          },
          search: {
            type: 'string',
            desc: '',
            optional: true,
          },
        },
        encodedParams: '',
      },
      {
        pathName: 'list/pages?offset=0',
        method: 'GET',
        params: {
          offset: {
            type: 'number',
            desc: '',
            optional: true,
          },
          domain: {
            type: 'string',
            desc: '',
            optional: true,
          },
          search: {
            type: 'string',
            desc: '',
            optional: true,
          },
        },
        encodedParams: '',
      },
      {
        pathName: 'list/analytics?offset=0&domain=a11ywatch.com',
        method: 'GET',
        params: {
          offset: {
            type: 'number',
            desc: '',
            optional: true,
          },
          domain: {
            type: 'string',
            desc: '',
            optional: true,
          },
          pageUrl: {
            type: 'string',
            desc: '',
            optional: true,
          },
        },
        encodedParams: '',
      },
    ],
  },
]
